const node = new URL('../../icons/node.png', import.meta.url).href

export default {
  type: 'Node',
  description: 'node shape',
  icon: node,
  group: ['etc'],
  model: {
    type: 'Node',
    cx: 100,
    cy: 100,
    strokeStyle: 'black',
    lineWidth: 1,
    fillStyle: 'red',
    hidden: true
  }
}
